import { Check } from "lucide-react";

import { cn } from "@/lib/utils";

export type Bubble = { role: "user" | "assistant"; content: string };

export interface SetupCheck {
  key: string;
  label: string;
  done: boolean;
}

export interface SetupProgress {
  checks: SetupCheck[];
  industry: string | null;
  done: number;
  total: number;
}

/** Un mensaje de la charla: Clara a la izquierda, la persona a la derecha. */
export function BubbleView({ bubble }: { bubble: Bubble }) {
  const fromClara = bubble.role === "assistant";
  return (
    <div className={cn("flex", fromClara ? "justify-start" : "justify-end")}>
      <p
        className={cn(
          "animate-pop-in max-w-[84%] px-3.5 py-3 text-sm leading-normal whitespace-pre-wrap",
          fromClara
            ? "bg-surface-selected rounded-[16px_16px_16px_4px]"
            : "bg-human text-rail-foreground rounded-[16px_16px_4px_16px]",
        )}
      >
        {bubble.content}
      </p>
    </div>
  );
}

/**
 * Lo que ya quedó configurado.
 *
 * Sin esto la charla es un chat que no se sabe si sirve. Con esto se ve que
 * cada respuesta deja algo guardado — y cuánto falta.
 */
export function ProgressStrip({ progress }: { progress: SetupProgress }) {
  return (
    <div className="mt-4">
      <p className="text-muted-foreground mb-2 text-center text-xs">
        {progress.done} de {progress.total} listo
      </p>
      <ul className="flex flex-wrap justify-center gap-1.5">
        {progress.checks.map((check) => (
          <li
            key={check.key}
            className={cn(
              "inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs",
              check.done
                ? "border-success/30 bg-success/8 text-success"
                : "border-border-strong text-muted-foreground",
            )}
          >
            {check.done && <Check aria-hidden className="size-3" />}
            {check.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
